import { render, staticRenderFns } from "./youtube-meet-embed.vue?vue&type=template&id=dc51a812&scoped=true&lang=pug&"
import script from "./youtube-meet-embed.vue?vue&type=script&lang=js&"
export * from "./youtube-meet-embed.vue?vue&type=script&lang=js&"
import style0 from "./youtube-meet-embed.vue?vue&type=style&index=0&id=dc51a812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc51a812",
  null
  
)

export default component.exports